export default __webpack_public_path__ + "5c8826e4058fcfd156ffefdd0b2bee37.png";